import shippingInfoReducer from './shippingInfoReducer';

export * from './shippingInfoActions';
export default shippingInfoReducer;
